module.exports = __webpack_public_path__ + "static/media/calendar-minus.aeb49449.svg";